import { render, staticRenderFns } from "./page-title.vue?vue&type=template&id=eb5b258e"
import script from "./page-title.vue?vue&type=script&lang=js"
export * from "./page-title.vue?vue&type=script&lang=js"
import style0 from "./page-title.less?vue&type=style&index=0&prod&lang=less&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports